import React from "react";
import D3blackbox from "./D3blackbox";
import * as d3 from "d3";
import Axis from "./Axis";
import moment from "moment";

//const Barchart = D3blackbox(function(anchor, props) {
const Barchart = D3blackbox(function(anchor, props, state) {
  console.log("INSIDE BARCHART DATA RECEIVED:");
  var forecasts = this.props.data.forecasts;
  console.log("forecasts: " + forecasts);

  let listforecasts = <span>Empty</span>;
  /*
  if (this.props.data.forecasts) {
    listforecasts = this.props.data.forecasts.map(forecast => (
      <span>{forecast.id}</span>
    ));
  }
*/

  //comparisonValue
  //d3comparison = d.compareValue;
  var compareValue = this.props.compareValue;
  var NoForecasts = this.props.data.forecasts.length;
  var forecasts = this.props.data.forecasts;
  var locationName = this.props.data.name;

  var maxTEMP = d3.max(forecasts, function(d) {
    return d[compareValue];
  });

  var minTEMP = d3.min(forecasts, function(d) {
    return d[compareValue];
  });

  /*
  if (maxTEMP > this.props.maxTempAllLocations) {
    this.props.setMaxTemp(maxTEMP);
  }
*/

  /*
  var xScale = d3
    .scaleLinear()
    .domain(
      forecasts.map(function(d) {
        return d.dt;
      })
    )
    .range([0, this.props.width]);

  var yScale = d3
    .scaleLinear()
    .domain([
      0,
      d3.max(forecasts, function(d) {
        return d[compareValue];
      })
    ])
    .range([this.props.height, 0]);
*/

  //var formatNumbers = d3.format(".2");
  //var yAxis = d3.axisLeft(yScale).tickFormat(formatNumbers);

  var svg = d3.select(this.anchor.current),
    margin = { top: 40, right: 20, bottom: 30, left: 40 },
    width = +this.props.width - margin.left - margin.right,
    height = +this.props.height - margin.top - margin.bottom;
  /*
  // set the ranges
  var x = d3.scaleTime().range([0, width]);

  x.domain(
    d3.extent(forecasts, function(d) {
      return d.date;
    })
  );
*/
  var tooltip = d3
    .select("body")
    .append("div")
    .attr("class", "toolTip");

  var dateScale = d3
    .scaleTime()
    .domain([new Date("2016-10-01"), new Date("2016-10-31")])
    .rangeRound([0, 600]);

  var x = d3
    .scaleBand()
    .rangeRound([0, width])
    .padding(0.1);

  x.domain(
    forecasts.map(function(d, index) {
      return d.dt;
    })
  );

  /*
// set the ranges
var x = d3.scaleTime().range([0, width]);
  
x.domain(d3.extent(lineData, function(d) { return d.date; }));
*/
  var y = d3.scaleLinear().rangeRound([height, 0]);

  y.domain([
    0,
    40
    /*
    d3.max(forecasts, function(d) {
      return d[compareValue];
    })
    */
  ]);

  var g = svg
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  /*
  // OLD X AXIS Create XAxis
  g.append("g")
    .attr("class", "axis axis--x")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x));
*/
  // Create YAxis

  // NEW X AXIS
  /*
  var format = d3.utcFormat("%p");
  //var format = d3.utcFormat("%DD:%H");

  var scT = d3
    //.scaleLinear()
    .scaleUtc()
    .domain(d3.extent(forecasts, d => d.dt))
    .nice()
    .rangeRound([0, width]);



  g.append("g")
    .attr("class", "axis axis--x")
    .attr("transform", "translate(0," + height + ")")
    //.call(d3.axisBottom(x));
    .call(
      d3.axisBottom(scT).tickFormat(format)
      //.ticks(d3.timeMinute.every(1))
    );

    */

  var xScale = d3
    .scaleLinear()
    //.domain([0, d3.max(dummyLineChartData.days, function(d) { return d[2]; })])
    .domain([0, 40])
    //.range([0, width]);

    .rangeRound([0, width - 20]);
  //

  //-------------------
  //--------------------

  var foo = [];
  var timeArr = [];
  for (var i = 1; i <= 40; i++) {
    foo.push(i);
  }

  forecasts.map(function(d, index) {
    //var formattedTime = moment.unix(d.dt).format("hhA"); // Too LONG
    var formattedTime = moment.unix(d.dt).format("hhA"); // Too LONG

    timeArr.push(formattedTime);
    console.log(
      "DATE No " + index + " IS: " + d.dt + " formattedTime= " + formattedTime
    );
  });

  //==================================
  // OLD WORKING AXIS START
  /*
  const x_scale = d3
    .scaleBand()
    .domain(
      timeArr.map(function(d) {
        return d;
      })
    )
    .rangeRound([0, width])
    .padding(0.1); //var dateArray = [array(40)];

  //var xAxis = d3.axisBottom(xScale).tickValues(foo); //SHOWS ALL TICKS INDEX
  var xAxis = d3
    .axisBottom(x_scale)
    // .ticks(40)
    .tickSize([5])
    .tickPadding(5);

  g.append("g")
    .attr("class", "axis axis--x")
    .attr("transform", "translate(0," + height + ")")
    .call(xAxis);

*/
  // OLD WORKING AXIS END
  //==================================

  //+++++++++++++++++++
  //+++++++++++++++++++
  //+++++++++++++++++++
  //+++++++++++++++++++
  //+++++++++++++++++++

  // NEW AXIS START -------->

  var skillScale = d3.scaleBand();
  var skillDomain = forecasts.map(function(d) {
    //return d.dt_txt; // WORKS!!!!!!!
    var formattedTime = moment.unix(d.dt).format("DD/MM hhA"); // TOO LONG
    //var formattedTime = moment.unix(d.dt).format("hhA"); // TOO LONG

    return formattedTime.toString();
  });
  skillScale.rangeRound([0, width]);
  skillScale.domain(skillDomain);

  var bottomAxis = d3.axisBottom(skillScale);

  g.append("g")
    .attr("id", "bottom-axis")
    .call(bottomAxis)
    .attr("transform", "translate(0," + height + ")");

  // NEW AXIS END -------->

  //+++++++++++++++++++
  //+++++++++++++++++++
  //+++++++++++++++++++
  //+++++++++++++++++++
  //+++++++++++++++++++

  g.append("g")
    .attr("class", "axis axis--y")
    .call(d3.axisLeft(y).tickValues([0, 10, 20, 30, 40]))
    //.call(d3.axisLeft(y).ticks(5))
    .append("text")
    .attr("transform", "rotate(-90)")
    .attr("y", 10)
    .attr("dy", "0.71em")
    .attr("text-anchor", "end")
    .text("Temperature");

  /*
  g.append("g")
    .attr("class", "y axis")
    .call(yAxis);
    */
  /*
// NEW
const scale = d3
      .scaleLinear()
      .domain([0, 10])
      .range([0, 200]);

    const axis = d3.axisBottom(scale);

    d3.select(this.gRef.current).call(axis);

*/

  // Create Bars
  g.selectAll(".bar")
    .data(forecasts)
    .enter()
    .append("rect")
    //.attr("class", "bar")
    //check if it is max temp
    .attr("class", function(d) {
      if (d[compareValue] == maxTEMP) {
        return "max-temp-bar";
      } else if (d[compareValue] == minTEMP) {
        return "min-temp-bar";
      } else {
        return "bar";
      }
    })
    .attr("x", function(d) {
      return x(d.dt);
    })
    .attr("y", function(d) {
      return y(d[compareValue]);
    })
    .attr("width", x.bandwidth())
    .attr("height", function(d) {
      return height - y(d[compareValue]);
    })
    .on("mousemove", function(d) {
      tooltip
        .style("left", d3.event.pageX - 5 + "px")
        .style("top", d3.event.pageY - 80 + "px")
        .style("display", "inline-block")
        .html(
          moment.unix(d.dt).format("DD/MM hhA") +
            "<br>" +
            "Temp: " +
            d.temp +
            "°C"
        );
    })
    .on("mouseout", function(d) {
      tooltip.style("display", "none");
    });

  // Ad text to bars with value - NOT WORKING!!!!
  g.selectAll(".bar")
    .append("text")
    .attr("class", "bar-text")
    .attr("x", d => x(d.dt) + x.bandwidth() / 2)
    //.attr("y", 50)
    //.attr("y", 0)
    .attr("y", d => y(d[compareValue]) + 30)
    //.attr("fill", "#ff0000")
    .attr("text-anchor", "middle")
    .text(d => d[compareValue]);

  // Weather images
  g.selectAll(".img")
    .data(forecasts)
    .enter()
    .append("svg:image")
    .attr("x", function(d) {
      return x(d.dt);
    })
    .attr("y", -20)
    .attr("width", 20)
    .attr("height", 24)
    .attr("xlink:href", function(d) {
      return "http://openweathermap.org/img/wn/" + d.icon + "@2x.png";
    })
    .on("mouseover", handleMouseOver)
    .on("mouseout", handleMouseOut);

  // Title Label
  g.append("text")
    .attr("class", "title-label")
    .text(
      locationName
      //+ NoForecasts +
      // " MaxTemp: " +
      // maxTEMP
    )
    .attr("transform", "translate(0, -20)");

  function handleMouseOver(d, i) {
    // Add interactivity
    //alert("MouseOver");
    // Use D3 to select element, change color and size
    d3.select(this)
      .transition()
      .attr("width", 60)
      .attr("height", 72)
      .attr("x", function(d) {
        return x(d.dt) - 20;
      })
      .attr("y", -44);
  }

  function handleMouseOut(d, i) {
    // Use D3 to select element, change color back to normal
    d3.select(this)
      .transition()
      .attr("width", 20)
      .attr("height", 24)
      .attr("x", function(d) {
        return x(d.dt);
      })
      .attr("y", -20);
    //fill: "black",
    //r: radius

    // Select text by id and then remove
    d3.select("#t" + d.x + "-" + d.y + "-" + i).remove(); // Remove text location
  }
});
//});

export default Barchart;
